import gql from "graphql-tag";

const APPLY_TO_PARTNER_WHITELIST = gql`
    mutation applyToPartnerWhitelist(
        $poolId: String!
        $code: String!
    ) {
        applyToPartnerWhitelist (
            applyToPartnerWhitelist: {
                poolId: $poolId
                code: $code
            }
        ) {
            poolId
            walletId
            amount
        }
    }
`

export default APPLY_TO_PARTNER_WHITELIST;